import {Component, OnInit} from '@angular/core';
import {IContent} from '../../administration/contents/contents';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {ArticleService} from '../services/article.service';

@Component({
    selector: 'kkk-article-list',
    templateUrl: './article-list.component.html',
    styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnInit {
    articles: IContent[];

    constructor(
        private _breadcrumbs: BreadcrumbsService,
        private _service: ArticleService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Tartalmak', instructions: ['/tartalmak']}).add({name: 'Hírek'});
        this._service.fetchAll().subscribe(
            articles => this.articles = articles,
            this._messenger.handleError
        );
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/article-list/article-list.component.ts